import React, { useState, useEffect } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import GoogleMap from "../../GmapAutoComplete/GoogleMap";
import { useStyles } from "../AssetDetails/AssetDetailsFormStyles";
import { withStyles } from "@material-ui/core/styles";
import { Close } from "@material-ui/icons";
import {
	Grid,
	FormControl,
	Typography,
	DialogTitle,
	IconButton,
	Slide,
	Dialog,
	DialogContent,
	DialogActions,
} from "@material-ui/core";
import { VendorDataAPI } from '../../API/VendorDataAPI';
import { UsStatesDataAPI } from '../../API/UsStatesDataAPI';

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: "0.75rem 1.5rem",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});

const CustomDialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<DialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}>
					<Close />
				</IconButton>
			) : null}
		</DialogTitle>
	);
});

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

const AddVendor = ({ vendorModalOpen, setVendorModalOpen, setSaveVendor }) => {
	const classes = useStyles();
	const [usStates, setUsStates] = useState([]);

	const [vendor, setVendor] = useState({
		//account_owner: "0050e000006SHHYAA4",
		id: "required(will get overwritten on save)",
		name: "",
		street: "",
		city: "",
		zip_code: "",
		state: "",
		country: "",
		billing_street: "",
		billing_city: "",
		billing_state: "",
		billing_postal_code: "",
		billing_country: "",
	});
	const [googleAddress, setGoogleAddress] = useState("");
	const isFormValid =
		!!vendor.name &&
		!!vendor.city &&
		!!vendor.state &&
		!!vendor.country &&
		!!vendor.zip_code &&
		!!vendor.street &&
		!!vendor.billing_city &&
		!!vendor.billing_state &&
		!!vendor.billing_postal_code &&
		!!vendor.billing_street &&
		!!vendor.billing_country;

	const submitVendor = async () => {
		setVendorModalOpen(false);
		let vendorId;
		const error =
			!vendor.name.length ||
			!vendor.city.length ||
			!vendor.zip_code.length ||
			!vendor.state.length ||
			!vendor.country.length ||
			!vendor.street.length ||
			!vendor.billing_city.length ||
			!vendor.billing_state.length ||
			!vendor.billing_country.length;
		if (error) {
			alert("Please input required fields!");
			return;
		} else {
			delete vendor.id;
			await VendorDataAPI.addVendor(vendor).then(resp => {
				vendorId = resp;
			});
			setSaveVendor(vendor);
		}
	};

	useEffect(() => {
		//stopping it to rerun everytime when assets accordian is opened.
		//now it runs only when the add Vendor modal is opened(that is the only time it is required, hence!)
		if (vendorModalOpen) {
			UsStatesDataAPI.getUsStates()
				.then((resp) => setUsStates(resp));
		}
	}, [vendorModalOpen]);

	useEffect(() => {
		if (vendor?.street) {
			const addressConcatenation = `${vendor?.street}, ${vendor?.city}, ${vendor?.zip_code}`;
			setGoogleAddress(addressConcatenation);
		}
	}, [vendor])

	const updateMapInfo = (mapInfo) => {
		setVendor({
			...vendor,
			country: mapInfo.country || "",
			street: `${mapInfo.streetNumber} ${mapInfo.street}` || "",
			city: mapInfo.city || "",
			zip_code: mapInfo.zipCode || "",
			state: mapInfo.state || "",
			billing_street: `${mapInfo.streetNumber} ${mapInfo.street}` || "",
			billing_city: mapInfo.city || "",
			billing_state: mapInfo.state || "",
			billing_postal_code: mapInfo.zipCode || "",
			billing_country: mapInfo.country || "",
		});
		setGoogleAddress(mapInfo.location);
	};

	return (
		<Dialog
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			TransitionComponent={Transition}
			onClose={() => setVendorModalOpen(false)}
			open={vendorModalOpen}
			maxWidth="md"
			fullWidth
			classes={{
				root: classes.vendorDialog,
			}}>
			<CustomDialogTitle
				id="simple-dialog-title"
				onClose={() => setVendorModalOpen(false)}>
				Add New Vendor
			</CustomDialogTitle>
			<DialogContent
				id="alert-dialog-description"
				dividers
				className={classes.vendorDialogContent}>
				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={12}>
						<TextField
							id="vendor"
							label="Vendor Name"
							required
							fullWidth
							value={vendor.name}
							error={vendor.name ? false : true}
							onChange={(e) => setVendor({ ...vendor, name: e.target.value })}
						/>
					</Grid>
				</Grid>
				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={12}>
						<GoogleMap
							id={"map-address-1"}
							variant="outlined"
							className="gps_address_input"
							placeholder="Enter address"
							updateMapInfo={updateMapInfo}
						/>
					</Grid>
				</Grid>
				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={6}>
						<TextField
							id="telephone"
							label="Telephone #"
							fullWidth
							required
							value={vendor.phone}
							error={vendor.phone ? false : true}
							onChange={(e) => setVendor({ ...vendor, phone: e.target.value })}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							id="fax"
							label="Fax #"
							fullWidth
							required
							value={vendor.fax}
							error={vendor.fax ? false : true}
							onChange={(e) => setVendor({ ...vendor, fax: e.target.value })}
						/>
					</Grid>
				</Grid>

				<Grid container direction="row" spacing={(0, 2)}>
					<Grid item xs={6} container direction="row">
						<Grid item xs={12}>

						</Grid>
						<Grid item xs={12}>
							<TextField
								id="street"
								name="street"
								label="Street"
								required
								fullWidth
								value={vendor.street?.trim?.() ?? undefined}
								error={vendor?.street?.trim?.()?.length > 0 ? false : true}
								onChange={(e) => {
									setVendor({ ...vendor, street: e.target.value });
								}}
							/>
						</Grid>

						<Grid item xs={12}>
							<TextField
								id="city"
								name="city"
								label="City"
								required
								fullWidth
								value={vendor.city}
								error={vendor.city ? false : true}
								onChange={(e) => {
									setVendor({ ...vendor, city: e.target.value });
								}}
							/>
						</Grid>
						<Grid item xs={12}>
							<FormControl fullWidth>
								{/* <InputLabel id="stateLabel" htmlFor="stateLabel">State</InputLabel> */}
								<TextField
									select
									id="state"
									label="State"
									placeholder="State"
									labelId="stateLabel"
									required
									fullWidth
									value={vendor?.state?.trim?.() ?? undefined}
									error={vendor?.state?.trim?.()?.length > 0 ? false : true}
									onChange={(e) => {
										setVendor({ ...vendor, state: e.target.value });
										//setUSState(e.target.value)
									}}>
									<MenuItem value={vendor.state}>{vendor.state}</MenuItem>
									{usStates &&
										usStates.map((state) => (
											<MenuItem key={state.name} value={state.name}>
												{state.name}
											</MenuItem>
										))}
								</TextField>
							</FormControl>
						</Grid>
						<Grid item xs={12}>
							<TextField
								id="zip"
								label="Zip Code"
								required
								fullWidth
								value={vendor.zip_code}
								error={vendor.zip_code ? false : true}
								onChange={(e) => {
									//setZip(e.target.value);
									setVendor({ ...vendor, zip_code: e.target.value });
								}}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								id="country"
								label="Country"
								required
								fullWidth
								value={vendor.country}
								error={vendor.country ? false : true}
								onChange={(e) => {
									//setCounty(e.target.value);
									setVendor({ ...vendor, country: e.target.value });
								}}
							/>
						</Grid>
					</Grid>
					<Grid item xs={6} container direction="row">
						<Grid item xs={12}>

						</Grid>
						<Grid item xs={12}>
							<TextField
								id="billing-street"
								label="Billing Street"
								fullWidth
								required
								value={vendor.billing_street}
								error={vendor.billing_street ? false : true}
								onChange={(e) =>
									setVendor({ ...vendor, billing_street: e.target.value })
								}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								id="billing-city"
								label="Billing City"
								fullWidth
								required
								value={vendor.billing_city}
								error={vendor.billing_city ? false : true}
								onChange={(e) => setVendor({ ...vendor, billing_city: e.target.value })}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								id="billing-state"
								label="Billing State"
								fullWidth
								required
								value={vendor.billing_state}
								error={vendor.billing_state ? false : true}
								onChange={(e) =>
									setVendor({ ...vendor, billing_state: e.target.value })
								}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								id="Billing-postal-code"
								label="Billing Postal Code"
								fullWidth
								required
								value={vendor.billing_postal_code}
								error={vendor.billing_postal_code ? false : true}
								onChange={(e) =>
									setVendor({ ...vendor, billing_postal_code: e.target.value })
								}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								id="billing-country"
								label="Billing Country"
								fullWidth
								required
								value={vendor.billing_country}
								error={vendor.billing_country ? false : true}
								onChange={(e) =>
									setVendor({ ...vendor, billing_country: e.target.value })
								}
							/>
						</Grid>
					</Grid>
				</Grid>

				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={12}>
						<TextField
							fullWidth
							id="address"
							label="Address"
							value={googleAddress}
							disabled={true}
							onChange={
								(e) => setGoogleAddress(e.target.value)
								// setVendor({ ...vendor, duns_street: e.target.value })
							}
						/>
					</Grid>
				</Grid>
				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={12}>

					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className={classes.vendorDialogAction}>
				<Button
					onClick={() => submitVendor()}
					variant="contained"
					disableElevation
					className={classes.vendorDialogButton}
					disabled={!isFormValid}>
					Submit
				</Button>
			</DialogActions>
		</Dialog>
	);
};
export default AddVendor;
